import { forwardRef, useId, type InputHTMLAttributes, type ReactNode } from 'react';

import styles from './Choice.module.css';

export const Radio = forwardRef<
  HTMLInputElement,
  Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
    label: ReactNode;
    description?: ReactNode;
    card?: boolean;
  }
>(function Radio({ label, description, card, id, disabled, checked, ...rest }, ref) {
  const autoId = useId();
  const inputId = id ?? autoId;
  return (
    <label
      htmlFor={inputId}
      className={[
        styles.choice,
        card ? styles.card : '',
        card && checked ? styles.cardChecked : '',
        disabled ? styles.disabled : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <span className={styles.box}>
        <input
          {...rest}
          ref={ref}
          id={inputId}
          type="radio"
          checked={checked}
          disabled={disabled}
          className={styles.native}
        />
        <span className={styles.radioVisual} aria-hidden="true">
          <span className={styles.radioDot} />
        </span>
      </span>
      <span className={styles.text}>
        <span className={styles.label}>{label}</span>
        {description && <span className={styles.description}>{description}</span>}
      </span>
    </label>
  );
});
